export default __webpack_public_path__ + "static/media/beforeribboncut_w320.cd3d9a27.jpeg";